import { ThemeProvider } from "@shared/providers/ThemeProvider";

type Props = {
  children: React.ReactNode;
  theme?: "dark" | "light";
};

export function RootLayout(props: Props) {
  const { children, theme } = props;

  if (theme) {
    return <ThemeProvider defaultTheme={theme}>{children}</ThemeProvider>;
  }

  return children;
}
